export default "__VITE_ASSET__CNG0rh3V__"